module.exports = __webpack_public_path__ + "img/1522233908.68156ed8.jpg";